import { createContext } from 'react';
import type { IPatient } from '../../../../common/interfaces/patient';

type AutoSaveStatus = 'idle' | 'saving' | 'saved';

export interface IEpisodeContext {
    autoSaveStatus: AutoSaveStatus;
    changeServiceIdForAddingProcess: (value: string) => void;
    changeShowRecommendations: (value: boolean) => void;
    isExternalHolter?: string;
    onConvertToConsult: (consultServiceId: string, procedureRequestId: string) => Promise<void>;
    onConvertToReferral: (referralServiceId: string, requestId: string) => Promise<void>;
    patient: IPatient;
    setAutoSaveStatus: React.Dispatch<React.SetStateAction<AutoSaveStatus>>;
}

export const EpisodeContext = createContext<IEpisodeContext | null>(null);
